import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../config.service';
import { BehaviorSubject, Subscriber } from 'rxjs';
import { AESService } from '../encryption/aes.service';


@Injectable(

)
export class ResetpasswordService {
id;
token;
  constructor(public http: HttpClient, public config: ConfigService,private enc : AESService) {
    this.id=this.enc.getItem('uid',true)
    this.token=this.enc.getItem('accesstoken',true)
  }
  resetPass(user: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin':'*','Content-Type': 'application/json', })
    };
    return this.http.put<any>(this.config.baseURL + '/user/resetForgetPassword', user, httpOptions)
      .map((res) => {
   // this.dataofpermissions.next(res.data.Role.rolepermission)
         return res }

      );
  }
  changepassword(user: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.enc.getItem('accesstoken',true) })
    };
    return this.http.post<any>(this.config.baseURL + '/user/changepassword', user, httpOptions)
      .map((res) => {
   // this.dataofpermissions.next(res.data.Role.rolepermission)
         return res }

      );
  }
}
